var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('mainHeader'),_c('mobileHeader'),_c('heroHeader'),_c('frontBlog'),_c('div',{staticClass:"main"},[_c('mainContents')],1),_c('footerBlock')],1)}
var staticRenderFns = []

export { render, staticRenderFns }